export class SuggestedLoansTermsTable {
    _id: string;
    borrowerStatus: string;
    borrowerSuggestedRate: number;
    borrowerSuggestedTenure: number;
    comment: string;
    createdAt: string;
    investedAmount: number;
    lenderId: string;
    lenderStatus: string;
    lenderSuggestedRate: number;
    lenderSuggestedTenure: number;
    name: string;
    updatedAt: string;
    generatedLoanId: string;
    loanAmount: number;
    indicatedLoanRate: number;
    indicatedLoanTenure: number;

    constructor(
        _id: string,
        borrowerStatus: string,
        borrowerSuggestedRate: number,
        borrowerSuggestedTenure: number,
        comment: string,
        createdAt: string,
        investedAmount: number,
        lenderId: string,
        lenderStatus: string,
        lenderSuggestedRate: number,
        lenderSuggestedTenure: number,
        name: string,
        updatedAt: string,
        generatedLoanId: string,
        loanAmount: number,
        indicatedLoanRate: number,
        indicatedLoanTenure: number,
    ) {
        this._id = _id;
        this.borrowerStatus = borrowerStatus;
        this.borrowerSuggestedRate = borrowerSuggestedRate;
        this.borrowerSuggestedTenure = borrowerSuggestedTenure;
        this.comment = comment;
        this.createdAt = createdAt;
        this.investedAmount = investedAmount;
        this.lenderId = lenderId;
        this.lenderStatus = lenderStatus;
        this.lenderSuggestedRate = lenderSuggestedRate;
        this.lenderSuggestedTenure = lenderSuggestedTenure;
        this.name = name;
        this.updatedAt = updatedAt;
        this.generatedLoanId = generatedLoanId;
        this.loanAmount = loanAmount;
        this.indicatedLoanRate = indicatedLoanRate;
        this.indicatedLoanTenure = indicatedLoanTenure;
    }
}
